module.exports = __webpack_public_path__ + "static/media/booking.593d1f13.png";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/travel/booking.png
// module id = 749
// module chunks = 0